import type { SupportedRepubName } from './types';

export type ValueBetsConfig = {
  aiProbability: string;
  aiProbabilityMax: { football: number; other: number };
  aiProbabilityShort: string;
  aiProbabilityTooltip: string;
  defaultEventDisplayName: string;
  defaultRanges: Partial<
    Record<'aiProbability' | 'expectedValue' | 'sportsData.hitRates.last10', `${number}:${number}`>
  >;
  defaultSortBy: string;
  expectedValue: string;
  expectedValueTooltip: string;
  impliedProbability: string;
  impliedProbabilityShort: string;
  impliedProbabilityTooltip: string;
};

/**
 * Value bets configurations for each repub
 */
export const VALUE_BETS_CONFIGS = {
  GZ: {
    aiProbabilityMax: { football: 80, other: 95 },
    defaultEventDisplayName: 'Serie A',
    defaultRanges: { aiProbability: '50:80', expectedValue: '0:200', 'sportsData.hitRates.last10': '40:100' },
    defaultSortBy: 'search-ev-bets_sportsbookProbability_desc',
    aiProbability: 'Probabilità IA',
    aiProbabilityShort: 'Probabilità IA',
    aiProbabilityTooltip:
      'La probabilità, stimata dalla nostra piattaforma AI, che la giocata si avveri rispetto alle aspettative dei bookmaker',
    impliedProbability: 'Probabilità Implicita',
    impliedProbabilityShort: 'Probabilità Implicita',
    impliedProbabilityTooltip: 'La probabilità che la giocata si avveri, secondo il bookmaker con la quota migliore',
    expectedValue: 'EV',
    expectedValueTooltip:
      'ROI previsto per questa giocata, stimato dal nostro modello AI predittivo. >0% - Conveniente, <0% = Non Conveniente, >10% = Molto Conveniente',
  },
  OC: {
    aiProbabilityMax: { football: 80, other: 80 },
    defaultEventDisplayName: 'EPL',
    defaultRanges: { aiProbability: '30:80' },
    defaultSortBy: 'search-ev-bets_sportsbookProbability_desc',
    aiProbability: 'AI Probability',
    aiProbabilityShort: 'AI Prob',
    aiProbabilityTooltip:
      'The % likelihood a projection will cover the consensus line based on our proprietary AI platform',
    impliedProbability: 'Implied Probability',
    impliedProbabilityShort: 'Im. Prob',
    impliedProbabilityTooltip: 'Implied probability the bet will win based on the sportsbook with best odds',
    expectedValue: 'EV',
    expectedValueTooltip:
      'The average ROI a bettor can expect for this bet based on our AI predictive model. >0% - Profitable Bet, <0% = Unprofitable Bet, >10% = Highly Profitable Bet',
  },
  US: {
    aiProbabilityMax: { football: 80, other: 95 },
    defaultEventDisplayName: 'NFL',
    defaultRanges: { aiProbability: '30:95' },
    defaultSortBy: 'search-ev-bets_expectedValue_desc',
    aiProbability: 'AI Probability',
    aiProbabilityShort: 'AI Prob',
    aiProbabilityTooltip:
      'The % likelihood a projection will cover the consensus line based on our proprietary AI platform',
    impliedProbability: 'Implied Probability',
    impliedProbabilityShort: 'Im. Prob',
    impliedProbabilityTooltip: 'Implied probability the bet will win based on the sportsbook with best odds',
    expectedValue: 'EV',
    expectedValueTooltip:
      'The average ROI a bettor can expect for this bet based on our AI predictive model. >0% - Profitable Bet, <0% = Unprofitable Bet, >10% = Highly Profitable Bet',
  },
  WS: {
    aiProbabilityMax: { football: 80, other: 80 },
    defaultEventDisplayName: 'All',
    defaultRanges: { aiProbability: '30:80' },
    defaultSortBy: 'search-ev-bets_sportsbookProbability_desc',
    aiProbability: 'AI Prob',
    aiProbabilityShort: 'AI Probability',
    aiProbabilityTooltip:
      'The % likelihood a projection will cover the consensus line based on our proprietary AI platform',
    impliedProbability: 'Implied Probability',
    impliedProbabilityShort: 'Im. Prob',
    impliedProbabilityTooltip: 'Implied probability the bet will win based on the sportsbook with best odds',
    expectedValue: 'EV',
    expectedValueTooltip:
      'The average ROI a bettor can expect for this bet based on our AI predictive model. >0% - Profitable Bet, <0% = Unprofitable Bet, >10% = Highly Profitable Bet',
  },
  // ES: {
  //   defaultEventDisplayName: 'All',
  //   defaultSortBy: 'search-ev-bets_sportsbookProbability_desc',
  //   aiProbability: 'Probabilidad según IA',
  //   aiProbabilityShort: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  //   aiProbabilityTooltip: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  //   impliedProbability: 'Probabilidad implícita',
  //   impliedProbabilityShort: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  //   impliedProbabilityTooltip: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  //   expectedValue: 'VE',
  //   expectedValueTooltip: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  // },
} satisfies Record<SupportedRepubName, ValueBetsConfig>;
